import { render, staticRenderFns } from "./BCTForm.vue?vue&type=template&id=5a290a53&scoped=true&"
import script from "./BCTForm.vue?vue&type=script&lang=js&"
export * from "./BCTForm.vue?vue&type=script&lang=js&"
import style0 from "./BCTForm.vue?vue&type=style&index=0&id=5a290a53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a290a53",
  null
  
)

export default component.exports